import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PaneHeaderService {

	// Change customer id from code and trigger selection in header
	changeCustomerSubject: Subject<number> = new Subject();
	constructor() { }
}
